/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './app.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from './components/header/header.component.ngfactory';
import * as i3 from '../../app/components/header/header.component';
import * as i4 from '@angular/router';
import * as i5 from '@angular/common';
import * as i6 from '../../app/helper';
import * as i7 from './components/navigation/navigation.component.ngfactory';
import * as i8 from '../../app/components/navigation/navigation.component';
import * as i9 from './components/footer/footer.component.ngfactory';
import * as i10 from '../../app/components/footer/footer.component';
import * as i11 from '../../app/app.component';
const styles_AppComponent:any[] = [i0.styles];
export const RenderType_AppComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),13,'div',[['class',
      'wrapper']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),1,'app-header',([] as any[]),(null as any),(null as any),(null as any),
          i2.View_HeaderComponent_0,i2.RenderType_HeaderComponent)),i1.ɵdid(3,114688,
          (null as any),0,i3.HeaderComponent,[i4.ActivatedRoute,i4.Router,i5.Location,
              i6.Helper],(null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['\n  '])),(_l()(),i1.ɵeld(5,0,(null as any),(null as any),1,'app-navigation',
          ([] as any[]),(null as any),(null as any),(null as any),i7.View_NavigationComponent_0,
          i7.RenderType_NavigationComponent)),i1.ɵdid(6,114688,(null as any),0,i8.NavigationComponent,
          [i4.ActivatedRoute,i4.Router,i5.Location,i6.Helper],(null as any),(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(8,0,(null as any),
          (null as any),4,'div',[['class','main']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(10,16777216,(null as any),(null as any),1,'router-outlet',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(11,212992,(null as any),0,i4.RouterOutlet,[i4.ChildrenOutletContexts,
          i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
          (null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),
      (_l()(),i1.ɵeld(15,0,(null as any),(null as any),1,'app-footer',([] as any[]),
          (null as any),(null as any),(null as any),i9.View_FooterComponent_0,i9.RenderType_FooterComponent)),
      i1.ɵdid(16,114688,(null as any),0,i10.FooterComponent,[i4.ActivatedRoute,i4.Router],
          (null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        _ck(_v,3,0);
        _ck(_v,6,0);
        _ck(_v,11,0);
        _ck(_v,16,0);
      },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-root',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i1.ɵdid(1,114688,(null as any),0,i11.AppComponent,([] as any[]),(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AppComponentNgFactory:i1.ComponentFactory<i11.AppComponent> = i1.ɵccf('app-root',
    i11.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZmJvb2tpbmcvYW5ndWxhci1jbGllbnQvc3JjL2FwcC9hcHAuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci93d3cvZmJvb2tpbmcvYW5ndWxhci1jbGllbnQvc3JjL2FwcC9hcHAuY29tcG9uZW50LnRzIiwibmc6Ly8vdmFyL3d3dy9mYm9va2luZy9hbmd1bGFyLWNsaWVudC9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvZmJvb2tpbmcvYW5ndWxhci1jbGllbnQvc3JjL2FwcC9hcHAuY29tcG9uZW50LnRzLkFwcENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJ3cmFwcGVyXCI+XG4gIDxhcHAtaGVhZGVyPjwvYXBwLWhlYWRlcj5cbiAgPGFwcC1uYXZpZ2F0aW9uPjwvYXBwLW5hdmlnYXRpb24+XG4gIDxkaXYgY2xhc3M9XCJtYWluXCI+XG4gICAgPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PlxuICA8L2Rpdj5cbjwvZGl2PlxuPGFwcC1mb290ZXI+PC9hcHAtZm9vdGVyPlxuIiwiPGFwcC1yb290PjwvYXBwLXJvb3Q+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBcUIsNENBQ25CO1VBQUE7aUVBQUEsVUFBQTtVQUFBO3VCQUFBLCtCQUF5QjtVQUFBLFdBQ3pCO1VBQUE7MkNBQUEsVUFBQTtVQUFBO01BQWlDLDRDQUNqQztVQUFBO1VBQUEsOEJBQWtCO01BQ2hCO1VBQUE7YUFBQTswREFBQTtVQUFBLDZCQUErQjtNQUMzQiwwQ0FDRjtNQUNOO1VBQUE7YUFBQTtVQUFBLDZCQUF5Qjs7UUFOdkI7UUFDQTtRQUVFO1FBR0o7Ozs7b0JDUEE7TUFBQTthQUFBO1VBQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.component.ngfactory.ts